import React, { useState } from 'react';
import logo from './assets/images/logo.png';
import { svg } from './assets/svg/common.js'
import { config } from './helper/configVariable.js'
import { useNavigate } from 'react-router-dom';
import { existUsername, createDbmailUser, getGeneralSettings } from './helper/apiHelper.js'

function SignUp() {
  const [userName, setUserName] = useState('');
  const [error, setError] = useState(null);
  const [isAvailable, setIsAvailable] = useState(false);
  const history = useNavigate();

  const checkAvailability = async (name) => {
    setIsAvailable(false);
    if (!name) return;
    if (!/^[a-zA-Z0-9._]+$/.test(name)) {
      setError("Sorry, only letters (a-z), numbers (0-9), and periods (. and _) are allowed.");
      return;
    }
    const isExist = await existUsername(name + '@' + config.DOMAIN);
    if (isExist.exists) {
      setError("Username Is not Available");
      return;
    }
    setIsAvailable(true);
    setError(null);
  }

  const confirmUsername = async (userName) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const createUser = await createDbmailUser(userName + '@' + config.DOMAIN, user.wallet.social_id);
    if (createUser.result) {
      let user = JSON.parse(localStorage.getItem('user'));
      user.wallet.username = userName + '@' + config.DOMAIN;
      user.wallet.user_id = createUser.result.user_id;
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('access_token', createUser.result.token);
      const responseSettings = await getGeneralSettings();
      if (responseSettings) {
        localStorage.setItem('timeZone', responseSettings.time_zone);
      }
      history('/home');
    } else {
      history('/');
    }
  }

  return (
    <div className='d-flex justify-content-center align-items-center min-vh-80'>
      <div className='col-8 login-section'>
        <div className='row'>
          <div className='col d-flex flex-column align-items-center justify-content-center'>
            <img src={logo} alt='logo' width="88" height="70" />
            <p className='x-bold'>Choose Your Unique Username</p>
            <p className='s-gray-text position-relative text-truncate'>Choose your unique username, this name will work as your dmail account as well as your Web3ID!</p>
          </div>
          <div className='col d-flex flex-column align-items-center justify-content-center mt-90'>
            <div className="input-values-sign-up-parent"><div className="input-values-sign-up" id="signupInput"><div className="input-field-div"><input type="text" id="username" placeholder="Username" value={userName} onChange={(event) => {
              setIsAvailable(false);
              let value = event?.target?.value?.trim()?.toLowerCase();
              setUserName(value)
            }} /><span className="domain-input-default gradient-text">@{config.DOMAIN}</span>{isAvailable ? svg.tick_active : svg.tick}</div></div></div>
            {error &&
              <div className="error-response-success error" >
                {svg.warning_svg}
                <span> {error} </span>
              </div>
            }
            {!isAvailable &&
              <button className={`signup-btn mt-4 ${userName ? 'gradient-bg' : ''}`} onClick={() => { checkAvailability(userName) }} ><span className='otp-text'>Confirm</span></button>
            }
            {isAvailable &&
              <button className={`signup-btn mt-4 gradient-bg`} onClick={() => { confirmUsername(userName) }} ><span className='otp-text'>Confirm "{userName}@{config.DOMAIN}"</span></button>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
